var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "mb-3" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-md-8 offset-md-2 col-12" }, [
        _c("div", { staticClass: "card" }, [
          _c("div", { staticClass: "card-body shadow-sm" }, [
            _c("h2", { staticClass: "text-center mt-2" }, [
              _vm._v(_vm._s(_vm.$t("message.booking_detail.solution_title")))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-flex align-items-center" }, [
              _c("img", {
                staticClass: "mr-3",
                attrs: { src: "/static/img/ic_cleaning.svg", width: "72" }
              }),
              _vm._v(" "),
              _c("h2", { staticClass: "my-auto" }, [
                _vm._v(_vm._s(_vm.$t("message.service.cleaning")))
              ])
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "list-unstyled why-choose-us-list mt-3" }, [
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title00"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title01"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title02"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title03"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title04"))
                )
              ]),
              _vm._v(" "),
              _c("li", [
                _c("i", {
                  staticClass: "fas fa-check-square -status-accepted"
                }),
                _vm._v(
                  "  " +
                    _vm._s(_vm.$t("message.booking_detail.solution_title05"))
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "text-center" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: { el: "#start-booking-form", offset: -80 },
                      expression: "{el:'#start-booking-form',offset: -80}"
                    }
                  ],
                  staticClass: "button button-large -green",
                  attrs: { href: "#" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.button.get_started")) +
                      "\n            "
                  )
                ]
              )
            ]),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c("h2", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fas fa-check -status-accepted" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.our_service.title")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row my-4" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm._v(
                  "\n              " +
                    _vm._s(
                      _vm.$t("message.booking_detail.our_service_subtitle")
                    ) +
                    "\n            "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8" }, [
                _c("h3", { staticClass: "service-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.our_service.bedroom_title")))
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "maininfo-list mt-4" }, [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom01")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom02")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom03")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom04")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom05")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom06")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom07")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bedroom08")))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _vm._m(2),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8" }, [
                _c("h3", { staticClass: "service-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.our_service.bathroom_title")))
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "maininfo-list mt-4" }, [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom01")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom02")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom03")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom04")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom05")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom06")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom07")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.bathroom08")))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row mt-4" }, [
              _vm._m(3),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-8" }, [
                _c("h3", { staticClass: "service-title" }, [
                  _vm._v(_vm._s(_vm.$t("message.our_service.kitchen_title")))
                ]),
                _vm._v(" "),
                _c("ul", { staticClass: "maininfo-list mt-4" }, [
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen01")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen02")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen03")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen04")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen05")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen06")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen07")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen08")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen09")))
                  ]),
                  _vm._v(" "),
                  _c("li", [
                    _vm._v(_vm._s(_vm.$t("message.booking_detail.kitchen10")))
                  ])
                ])
              ])
            ]),
            _vm._v(" "),
            _vm._m(4),
            _vm._v(" "),
            _c("h2", { staticClass: "text-center" }, [
              _c("i", { staticClass: "fas fa-times -status-alert" }),
              _vm._v(
                " " +
                  _vm._s(_vm.$t("message.our_service.exclude_title")) +
                  "\n          "
              )
            ]),
            _vm._v(" "),
            _c("ul", { staticClass: "maininfo-list mb-0" }, [
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.booking_detail.exclude01")))
              ]),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.booking_detail.exclude02")))
              ]),
              _vm._v(" "),
              _c(
                "li",
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.booking_detail.exclude03")) +
                      "\n              "
                  ),
                  _c(
                    "router-link",
                    {
                      attrs: { to: "/service-requests/booking?service_id=13" }
                    },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.$t("message.booking_detail.exclude04")) +
                          "\n              "
                      )
                    ]
                  ),
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.booking_detail.exclude05")) +
                      "\n            "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("li", [
                _vm._v(_vm._s(_vm.$t("message.booking_detail.exclude06")))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "my-4 text-center" }, [
              _c(
                "a",
                {
                  directives: [
                    {
                      name: "scroll-to",
                      rawName: "v-scroll-to",
                      value: { el: "#start-booking-form", offset: -80 },
                      expression: "{el:'#start-booking-form',offset: -80}"
                    }
                  ],
                  staticClass: "button button-large -green",
                  attrs: { href: "#" }
                },
                [
                  _vm._v(
                    "\n              " +
                      _vm._s(_vm.$t("message.button.get_started")) +
                      "\n            "
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-5" }, [_c("hr")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded img-center",
        attrs: { src: "/static/img/coverage-bedroom.jpg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded img-center",
        attrs: { src: "/static/img/coverage-bathroom.jpg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4" }, [
      _c("img", {
        staticClass: "img-fluid rounded img-center",
        attrs: { src: "/static/img/coverage-kitchen.jpg" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "my-5" }, [_c("hr")])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-360df837", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-360df837","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/components/BookingDetail.vue
// module id = 1709
// module chunks = 0